import React from "react";
import AddNewUserForm from "../../components/UserManagement/AddNewUserForm";
import {
    ModalOverlay,
    ModalBody,
    ModalHeader,
    ModalHeaderTitle,
    ModalHeaderCloseButton,
} from "../../components/Util/Modal.elements";

const AddNewUserPage = (props) => {
    return (
        <ModalOverlay open={props.show} onClose={props.handleClose} fullWidth>
            <ModalBody>
                <ModalHeader $marginBottom={28}>
                    <ModalHeaderTitle>ADD NEW USER</ModalHeaderTitle>
                    <ModalHeaderCloseButton type="button" onClick={props.handleClose}>
                        &times;
                    </ModalHeaderCloseButton>
                </ModalHeader>

                <AddNewUserForm onClose={props.handleClose} />
            </ModalBody>
        </ModalOverlay>
    );
};

export default AddNewUserPage;